var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/hardware/keyboard_arrow_left_24px",
    d: "M14.2049 10.59L9.62492 6L14.2049 1.41L12.7949 0L6.79492 6L12.7949 12L14.2049 10.59Z",
    fill: "#F0EDEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon/hardware/keyboard_arrow_left_24px_2",
    d: "M8.20492 10.59L3.62492 6L8.20492 1.41L6.79492 0L0.794922 6L6.79492 12L8.20492 10.59Z",
    fill: "#F0EDEE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstGrey);
export default __webpack_public_path__ + "static/media/firstGrey.0ae856c1dcaed775ee7a6a81d17bf759.svg";
export { ForwardRef as ReactComponent };